import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore curated top lists of airlines on First-Class.com. Find the best carriers, services, and travel options for your premium journey'
          }
        />
        <title>Airline Toplists: Ranking the Best Airlines Worldwide</title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Airlines"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
